var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"registryTypeName",attrs:{"title":_vm.registryTypeName},domProps:{"textContent":_vm._s(_vm.registryTypeText)}})}
var staticRenderFns = []

export { render, staticRenderFns }